import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function submitFoundingCohortApplication(payload) {
  const response = await axios.post(
    `${API_BASE_URL}/api/founding-cohort/applications/`,
    payload
  );
  return response.data;
}

export async function validateFoundingInvitation(token) {
  const response = await axios.get(
    `${API_BASE_URL}/api/founding-cohort/invitations/validate/`,
    { params: { token } }
  );
  return response.data;
}
